import React from 'react';
import { withTranslation } from '@wix/yoshi-flow-editor';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import PlayIcon from '../../../../../static/images/play.svg';

import styles from '../overlay.scss';

class OverlayPlayButton extends React.Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,

    children: PropTypes.node,
    isFocusable: PropTypes.bool,
    isIconOnly: PropTypes.bool,

    className: PropTypes.string,
    iconClassName: PropTypes.string,

    ariaHidden: PropTypes.bool,
  };

  static defaultProps = {
    isFocusable: true,
    isIconOnly: false,
    ariaHidden: false,
  };

  handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();

    this.props.onClick();
  };

  render() {
    const {
      children,
      isIconOnly,
      isFocusable,
      className,
      iconClassName,
      ariaHidden,
      t,
    } = this.props;

    const classNames = classnames(styles.button, className, {
      [styles['only-icon']]: isIconOnly,
    });

    return (
      <button
        className={classNames}
        onClick={this.handleClick}
        data-hook="overlay-play-button"
        aria-hidden={ariaHidden}
        tabIndex={isFocusable ? 0 : -1}
        aria-label={t('widget.accessibility.play-video')}
      >
        <PlayIcon className={classnames(styles.icon, iconClassName)} />
        {children && <span className={styles.text}>{children}</span>}
      </button>
    );
  }
}

export default withTranslation()(OverlayPlayButton);
